export default "__VITE_ASSET__B6qMKzF7__"